import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '@environment';
import { provideNgxWebstorage, withNgxWebstorageConfig, withLocalStorage } from 'ngx-webstorage';
import { ConfigurationService } from '@services/configuration.service';
import { WindowService } from '@core/window.service';
import * as Sentry from '@sentry/angular';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// --- SENTRY [START] ---
export function provideErrorHandler() {
  const isProduction = environment.envName === 'Production';
  const hasSentry = environment.sentry !== null;
  if (hasSentry && isProduction) {
    Sentry.init({
      dsn: environment.sentry,
      environment: environment.envName,
      ignoreErrors: [
        /cookie-notice-container/,
      ],
    });
    
    return Sentry.createErrorHandler({
      showDialog: false,
    });
  }
  return new ErrorHandler();
}
// --- SENTRY [END] ---

// --- TRANSLATE [START] ---
export class SafeTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): Observable<object> {
    return this.http
      .get<object>(
        `./assets/i18n/${lang}.json?version=${environment.version}`,
      )
      .pipe(
        catchError(() => of({})),
      );
  }
}

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new SafeTranslateLoader(http);
}
// --- TRANSLATE [END] ---



@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
  CommonModule,
  BrowserModule,
  BrowserAnimationsModule,
  AppRoutingModule,
  HttpClientModule,
  TranslateModule.forRoot({
    loader: {
    provide: TranslateLoader,
    useFactory: createTranslateLoader,
    deps: [HttpClient],
    },
    }),
  ],
  providers: [
  provideNgxWebstorage(
    withLocalStorage(),
    withNgxWebstorageConfig({
      prefix: 'PinPag:Partner',
      separator: ':',
      caseSensitive: true }),
  ),
  {provide: APP_BASE_HREF, useValue: '/'},
  {provide: ErrorHandler, useFactory: provideErrorHandler},
  WindowService,
  ConfigurationService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
  })
export class AppModule {}
